import { LineStyleMarkerShape } from './line-style-select.types';

/** SVG path for a marker centred on (cx, cy); mirrors Highcharts' own symbol shapes. */
export function markerShapePath(
  shape: LineStyleMarkerShape,
  cx: number,
  cy: number,
  r: number
): string {
  switch (shape) {
    case 'circle':
      return `M ${cx - r} ${cy} a ${r} ${r} 0 1 0 ${
        r * 2
      } 0 a ${r} ${r} 0 1 0 ${-r * 2} 0 Z`;
    case 'square':
      return `M ${cx - r} ${cy - r} H ${cx + r} V ${cy + r} H ${cx - r} Z`;
    case 'diamond':
      return `M ${cx} ${cy - r} L ${cx + r} ${cy} L ${cx} ${cy + r} L ${
        cx - r
      } ${cy} Z`;
    case 'triangle':
      return `M ${cx} ${cy - r} L ${cx + r} ${cy + r} L ${cx - r} ${cy + r} Z`;
    case 'triangle-down':
      return `M ${cx - r} ${cy - r} L ${cx + r} ${cy - r} L ${cx} ${cy + r} Z`;
  }
}
